module.exports = __webpack_public_path__ + "img/avatar5.fdcc9493.png";